import { EntityTaggingProvider } from './EntityTaggingProvider'
import { rentalTaggingAdapter } from './rentalTaggingAdapter'
import type { TaggingProviderProps } from './TaggingProvider.types'

export const TaggingProvider = (props: TaggingProviderProps) => (
  <EntityTaggingProvider {...props} adapter={rentalTaggingAdapter} />
)
